/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transit-detail',
  templateUrl: './transit-detail.component.html',
  styleUrls: ['./transit-detail.component.scss']
})
export class TransitDetailComponent implements OnInit {
  question: any;
  items: any;
  filteredItems: any;
  answer: any;
  prompt = '';
  searchPlaceholder: string = this.translate.instant('SURVEY_SEARCH_PLACEHOLDER');

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private translate: TranslateService
  ) {}

  onClickRadio(item) {
    this.popoverCtrl.dismiss(item);
  }

  async filterList(evt) {
    this.items = this.navParams.data.items;
    const searchTerm = evt.srcElement.value;

    if (!searchTerm) {
      return;
    }

    this.items = this.items.filter((item) => {
      if (item.text && searchTerm) {
        return item.text.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
      }
    });
  }

  lastItem(index) {
    return this.items.length > 1 && index == this.items.length - 2; // 'Other' at end
  }

  ngOnInit() {
    this.question = this.navParams.data.question;
    this.items = this.navParams.data.items;
    this.answer = this.navParams.data.answer;
    this.prompt = this.navParams.data.prompt;
  }
}
